import { Button, Card, CardBody, Col, ListGroup, ListGroupItem, ListProps, Row } from 'reactstrap';

import { Image } from '../coreComponents/Image';
import CommonCardHeader from './CommonCardHeader';
import { ListItemProps } from '../types/List';
import { t } from 'i18next';

const List = (listProps: ListProps) => {
  return (
    <Col md="12">
      <Card>
        <CommonCardHeader title={t('bot.transcription')} />
        <CardBody>
          <Row>
            {listProps.handleOpenCreate && (
              <Col sm="6" className="justify-content-start">
                <Button
                  type="button"
                  onClick={() => listProps.handleOpenCreate()}
                  color="success"
                  outline
                  className="mb-4"
                >
                  {t('bot.createRecord')}
                </Button>
              </Col>
            )}
            {listProps.hasNewCommetsToSave && (
              <Col sm="6" className="d-flex justify-content-end">
                <Button
                  type="button"
                  onClick={() => listProps.handleSyncChanges()}
                  color="primary"
                  outline
                  className="mb-4"
                >
                  {t('bot.syncChanges')}
                </Button>
              </Col>
            )}
          </Row>

          <ListGroup>
            {listProps.data.listData &&
              listProps.data.listData.map((item: ListItemProps, index: number) => (
                <ListGroupItem action className={`${item.class} d-flex`} key={item.id}>
                  <div className="d-flex w-100 justify-content-between align-items-center">
                    <div className="list-wrapper">
                      {item.image && <Image className="list-img" src={item?.image} alt="" />}
                      <div className="list-content">
                        <h6 className={'mb-1'}>{item.speaker}</h6>
                        <p className="mb-1 text-muted">
                          {item.timestamp
                            ? new Date(item.timestamp).toLocaleDateString('uk-UA', {
                                hour: '2-digit',
                                minute: '2-digit',
                                second: '2-digit',
                              })
                            : ''}
                        </p>
                        <p>{item.text}</p>
                      </div>
                    </div>
                  </div>
                  {item.subtext && <p className="mb-1">{item.subtext}</p>}
                  <div className="d-flex flex-column gap-3 ms-3">
                    <Button
                      type="button"
                      onClick={() => listProps.handleEditText(item)}
                      color="warning"
                      outline
                      className="w-100"
                    >
                      {t('bot.transcriptionEditRow')}
                    </Button>
                    <Button
                      type="button"
                      onClick={() => listProps.handleDeleteItem(item)}
                      color="danger"
                      outline
                      className="w-100"
                    >
                      {t('bot.transcriptionRemoveRow')}
                    </Button>
                  </div>
                </ListGroupItem>
              ))}
          </ListGroup>
        </CardBody>
      </Card>
    </Col>
  );
};
export default List;
